import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

const CONFIRM_TITLE = 'Confirm support request completed';
const SUCCESS_TITLE = 'Import Request Complete';

export default function CompletedSupportModal({
  request,
  shown,
  onChangeErrors,
  onChangeRequest,
  onClose,
  onUpdateImportRequest
}) {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    if (shown) {
      setShowSuccessMessage(false);
    }
  }, [shown]);

  const handleConfirm = () => {
    onUpdateImportRequest({ supportStatus: 'completed' }, (importRequest) => {
      onChangeRequest(importRequest);
      setShowSuccessMessage(true);
    }, (errors) => {
      onChangeErrors(errors);
      onClose();
    });
  };

  const renderSuccessMessage = () => (
    <div className="text-center">
      <div className="p-2">
        <FontAwesomeIcon color="#98c966" icon={faCheckCircle} size="4x"/>
      </div>
      <div>
        <h3>Import Request Complete</h3>
        {request.requestedBy} has received a confirmation email that this import request have has been completed
      </div>
    </div>
  );

  const renderConfirmMessage = () => (
    <div className="text-center">
      <div className="p-2">
        <FontAwesomeIcon className="text-danger mb-2" icon={faExclamationTriangle} size="2x"/>
      </div>
      <div>
        By clicking yes below, you are confirming you have completed the support request
      </div>
    </div>
  );

  const renderBody = () => {
    return showSuccessMessage ? renderSuccessMessage() : renderConfirmMessage();
  };

  const renderControls = () => {
    if (showSuccessMessage) {
      return <button className="btn btn-sm btn-create" type="button" onClick={onClose}>Done</button>;
    }

    return (
      <React.Fragment>
        <button className="btn btn-sm btn-cancel" type="button" onClick={onClose}>Cancel</button>
        <button className="btn btn-sm btn-save" type="button" onClick={handleConfirm}>Yes, confirm</button>
      </React.Fragment>
    );
  };

  return (
    <Modal show={shown} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {showSuccessMessage ? SUCCESS_TITLE : CONFIRM_TITLE}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {renderBody()}
      </Modal.Body>
      <Modal.Footer>
        {renderControls()}
      </Modal.Footer>
    </Modal>
  );
}

CompletedSupportModal.propTypes = {
  request: PropTypes.PropTypes.shape({
    requestedBy: PropTypes.string
  }).isRequired,
  shown: PropTypes.bool.isRequired,
  onChangeErrors: PropTypes.func.isRequired,
  onChangeRequest: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdateImportRequest: PropTypes.func.isRequired
};
